"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOW_PRIORITY_STREAM = exports.HIGH_PRIORITY_STREAM = exports.AGORA_ENCODER_CONFIG = void 0;
var AGORA_ENCODER_CONFIG = exports.AGORA_ENCODER_CONFIG = {
  width: 1280,
  height: 720,
  bitrateMax: 1200,
  bitrateMin: 100,
  frameRate: 30
};
var HIGH_PRIORITY_STREAM = exports.HIGH_PRIORITY_STREAM = 0;
var LOW_PRIORITY_STREAM = exports.LOW_PRIORITY_STREAM = 1;